import { ContextStore } from 'bernie-core';
import { getBexApiContext } from 'bernie-graphql';

import { AdditionalHeaderInput, PropertyInfoDetails, PropertyInfoOffers } from '__generated__/api';

export const getPropertyInfoInput = (
  context: ContextStore,
  criteria: any,
  propertyId: string,
  travelAd?: any
): PropertyInfoDetails.Variables | PropertyInfoOffers.Variables => ({
  context: getBexApiContext(context),
  propertyId,
  requestContext: {
    queryParams: getQueryString(getUpdatedCriteria(criteria, travelAd)),
    additionalHeaders: getAdditionalHeaders(context)
  }
});

export const getUpdatedCriteria = (criteria: any, travelAd?: any): any => {
  if (travelAd) {
    const data = Object.assign({}, criteria);
    if (travelAd.testVersionOverride) {
      data.testVersionOverride = travelAd.testVersionOverride;
    }
    data.trackingData = travelAd.trackingData;
    data.rank = travelAd.rank;
    data.candidateHmGuid = travelAd.candidateHmGuid;
    data.beaconIssued = travelAd.beaconIssued;
    data.slots = travelAd.slots;
    data.position = travelAd.position;
    data.isLinkOff = travelAd.clickRedirectLinkoffTrackingUrl !== undefined;

    return data;
  }

  return criteria;
};

export const getQueryString = (criteria: any): string => {
  const query: string[] = [];
  for (const pk in criteria) {
    if ({}.hasOwnProperty.call(criteria, pk)) {
      const pkValue = criteria[pk];
      if (pkValue && (typeof pkValue === 'string' || typeof pkValue === 'number' || typeof pkValue === 'boolean')) {
        query.push(`${encodeURIComponent(pk)}=${encodeURIComponent(pkValue)}`);
      }
    }
  }

  return query.join('&');
};

export const getAdditionalHeaders = (context: ContextStore): AdditionalHeaderInput[] => {
  if (!context) {
    return [];
  }

  const { deviceId, remoteAddress, userAgent } = context;

  return [
    deviceId && { name: 'X-MC1-GUID', value: `${context.deviceId}` },
    remoteAddress && { name: 'X-REMOTE-ADDR', value: context.remoteAddress },
    userAgent && { name: 'X-USER-AGENT', value: context.userAgent },
    { name: 'X-USER-STATE', value: (context.user && context.user.authState) || 'UNKNOWN' }
  ].filter(Boolean);
};
